import React, { useRef, useState } from "react";
import {
    I2cInput,
    I2cCheckboxGroup,
    I2cListItem,
    I2cCheckbox, I2cRadioGroup, I2cRadioButton
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { enrollment_Url_Platform, enrollment_Url_Type } from "./stringUtils";
const ManageOutsideI2cPlatform = ({ control, handleValueChanges, methods, errors }) => {
    const checkboxRef = useRef(null);
    const handleCheckboxChange = (event, fieldName) => {
        const SelectedNetworkValue = event;
        let updatedSelectedNetworks = [
            ...(methods.getValues(fieldName) ?? []),
        ];
        if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
            updatedSelectedNetworks = updatedSelectedNetworks.filter(
                (card) => card !== SelectedNetworkValue,
            );
        } else {
            updatedSelectedNetworks.push(SelectedNetworkValue);
        }
        methods.setValue(fieldName, updatedSelectedNetworks);
        methods.trigger();
        handleValueChanges();
    };
    return (
        <>
            <div i2c-grid="12">
                <div className="single-field-wrapper">
                    <div className="custom-label mb-6">
                        Do you want to link your enrollment platform to the i2c platform?
                    </div>
                    <Controller
                        name="card_enrollment_link_enrollment_platform_to_i2c"
                        control={control}
                        render={({ field }) => (
                            <I2cRadioGroup
                                label=""
                                {...field}
                                name="card_enrollment_link_enrollment_platform_to_i2c"
                                onI2cChange={(e) => {
                                    field.onChange(e);
                                    if(e.target.value === "No"){
                                        methods.setValue("card_enrollment_card_enrollment_url_type","")
                                        methods.setValue("card_enrollment_card_enrollment_url","")
                                        methods.setValue("card_enrollment_url_platform",[])
                                    }
                                    methods.trigger();
                                    handleValueChanges();
                                }}
                            >
                                {["Yes", "No"].map((eP, index) => (
                                    <I2cRadioButton
                                        key={index}
                                        checked={
                                            methods.watch("card_enrollment_link_enrollment_platform_to_i2c") === eP
                                        }
                                        value={eP}
                                    >
                                        {eP}
                                    </I2cRadioButton>
                                ))}
                            </I2cRadioGroup>
                        )}
                    />
                    <ErrorMessage
                        show={
                            errors.card_enrollment_link_enrollment_platform_to_i2c &&
                                methods.formState.touchedFields.card_enrollment_link_enrollment_platform_to_i2c
                                ? true
                                : false
                        }
                        message={errors.card_enrollment_link_enrollment_platform_to_i2c?.message ?? "Invalid input"}
                    />
                </div>
            </div>
            {
                methods.watch("card_enrollment_link_enrollment_platform_to_i2c") === "Yes" && (
                    <>
                        <div i2c-grid="12">
                            <div className="custom-label mb-6">Card Enrollment URL</div>
                            <div className="single-field-wrapper">
                                <Controller
                                    name="card_enrollment_card_enrollment_url_type"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cRadioGroup
                                            label=""
                                            {...field}
                                            name="card_enrollment_card_enrollment_url_type"
                                            onI2cChange={(e) => {
                                                field.onChange(e);
                                                if(e.target.value !== "Custom URL"){
                                                    methods.setValue("card_enrollment_card_enrollment_url","")
                                                }
                                                methods.trigger();
                                                handleValueChanges();
                                            }}
                                        >
                                            {enrollment_Url_Type.map((eut, index) => (
                                                <I2cRadioButton
                                                    key={index}
                                                    checked={
                                                        methods.watch("card_enrollment_card_enrollment_url_type") === eut
                                                    }
                                                    value={eut}
                                                >
                                                    {eut}
                                                </I2cRadioButton>
                                            ))}
                                        </I2cRadioGroup>
                                    )}
                                />
                                <ErrorMessage
                                    show={
                                        errors.card_enrollment_card_enrollment_url_type &&
                                            methods.formState.touchedFields.card_enrollment_card_enrollment_url_type
                                            ? true
                                            : false
                                    }
                                    message={errors.card_enrollment_card_enrollment_url_type?.message ?? "Invalid input"}
                                />
                            </div>
                        </div>
                        {
                            methods.watch("card_enrollment_card_enrollment_url_type") === "Custom URL" && (
                                <div i2c-grid="12 6@md">
                                    <div className="custom-label mb-6">
                                        Custom URL
                                    </div>
                                    <div className="single-field-wrapper">
                                        <Controller
                                            name="card_enrollment_card_enrollment_url"
                                            control={control}
                                            render={({ field }) => (
                                                <I2cInput
                                                    {...field}
                                                    className="single-input-field"
                                                    placeholder="www.i2cinc.com/enrollment"
                                                    onI2cInput={(e) => {
                                                        const value = e.target.value;
                                                        field.onChange(value);
                                                        handleValueChanges();
                                                    }}
                                                    size="large"
                                                    name={"card_enrollment_card_enrollment_url"}
                                                    prefix_label="http://"
                                                >

                                                </I2cInput>
                                            )}
                                        />
                                    </div>
                                </div>
                            )
                        }
                        <div i2c-grid="12 12@md">
                            <div className="custom-label mb-1-5">
                                Please select the platform where you want to add the URL:
                            </div>
                            <Controller
                                name="card_enrollment_url_platform"
                                control={control}
                                render={({ field }) => (
                                    <I2cCheckboxGroup name="card_enrollment_url_platform" ref={checkboxRef}>
                                        <div i2c-grid="grid gap-sm">
                                            {enrollment_Url_Platform.map((card, index) => (
                                                <div key={index} i2c-grid="12 6@md">
                                                    <I2cListItem
                                                        variant="receipt"
                                                        label={card.label}
                                                        sublabel=""
                                                        value=""
                                                        type="checkbox"
                                                        checked={methods
                                                            .watch("card_enrollment_url_platform")
                                                            .includes(card.value)}
                                                        onI2cCheckboxClicked={(e) =>
                                                            handleCheckboxChange(card.value, "card_enrollment_url_platform")

                                                        }
                                                    >
                                                        <I2cCheckbox
                                                            slot="prefix"
                                                            value={card.value}
                                                            label=""
                                                            ignoreTab
                                                            filled
                                                            checked={methods
                                                                .watch("card_enrollment_url_platform")
                                                                .includes(card.value)}
                                                            className="customCheckbox"
                                                        ></I2cCheckbox>
                                                    </I2cListItem>
                                                </div>
                                            ))}
                                        </div>
                                    </I2cCheckboxGroup>
                                )}
                            />
                        </div>
                    </>
                )
            }
        </>
    );
};

export default ManageOutsideI2cPlatform;
